import * as React from 'react';

import InputRadio from 'components/inputs/input-radio/InputRadio';

import { __t, applyTranslations } from 'utils/language';
import { MULTI } from 'modules/insights/sov/utils/queries/sov-queries';

import './sov-queries-input-radio.scss';

import type { SOVQueryType } from 'modules/insights/sov/types';

import type { SyntheticEvent } from 'react';

applyTranslations(require('modules/insights/sov/components/queries/modals/sov-queries-modal.i18n.json'));

type Props = {
  queryType: SOVQueryType,
  isChecked: boolean,
  isDisabled: boolean,
  onChange: (a: SOVQueryType) => void,
  onRefCallbackSingle: (a?: HTMLInputElement | null) => void,
  onRefCallbackMulti: (a?: HTMLInputElement | null) => void
};

const MODAL_MSG_KEY = 'sov_queries_modal';

class SOVQueriesInputField extends React.PureComponent<Props> {
  handleChange = (event: SyntheticEvent<HTMLInputElement>): void => {
    const { onChange } = this.props;
    const target = event.currentTarget;
    const value: SOVQueryType = target.value;

    onChange(value);
  };

  renderRadio(): React.ReactNode {
    const { queryType, isChecked, isDisabled, onRefCallbackSingle, onRefCallbackMulti } = this.props;

    return (
      <InputRadio
        refCallback={queryType === MULTI ? onRefCallbackMulti : onRefCallbackSingle}
        id={`sov-queries-input-radio__radio-${queryType}`}
        name="queryInputRadio"
        label={__t(`${MODAL_MSG_KEY}.messages.define_${queryType}`)}
        value={queryType}
        checked={isChecked}
        disabled={isDisabled}
        labelClassName="sov-queries-input-radio__radio"
        onChange={this.handleChange}
        data={{ type: queryType }}
      />
    );
  }

  render(): React.ReactNode {
    return (
      <div className="sov-queries-input-radio">
        {this.renderRadio()}
      </div>
    );
  }
}

export default SOVQueriesInputField;
